import React, {useMemo} from "react";
import {
    UserTenthTwelfthPercentage,
    RangeInputSelectedValue,
} from "../../../../containers/RegistrationLoginPage/types";
import RangeInput from "../../../RangeInput/index";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
    numberValidation,
    regNumberValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface TenthTwelthPercentageInterface {
    configuration: UserTenthTwelfthPercentage;
}

const TenthTwelthPercentage: React.FC<TenthTwelthPercentageInterface> = ({
    configuration,
}: TenthTwelthPercentageInterface) => {
    const {editable, values, selectedValue, fieldName} = configuration;
    const newClass =
        useSelector(
            (state: RootStore) => state.RegistrationLoginPage.bachelorFields?.currentClass,
        ) ?? "10";
    const defaultValue = selectedValue ? selectedValue.selectedValue : null;

    const newSelectedValue =
        values && defaultValue
            ? defaultValue < values.min
                ? values.min
                : defaultValue > values.max
                ? values.max
                : defaultValue
            : defaultValue;

    return useMemo(() => {
        return (
            <Field<RangeInputSelectedValue>
                name={fieldName}
                key={`${fieldName}_${newClass}`}
                validate={composeValidators(
                    regRequiredValidate(
                        `Please move slider to select class ${newClass}th percentage`,
                    ),
                    numberValidation(values?.min, values?.max, values?.step),
                    regNumberValidate(`Invalid ${newClass}th percentage`),
                )}
                initialValue={newSelectedValue}
                validateFields={[]}
            >
                {(props) => {
                    return (
                        <RangeInput
                            heading={`Class ${newClass}th percentage`}
                            editable={editable}
                            values={values}
                            type="Percentage"
                            isFocused={props.meta.active}
                            isTouched={props.meta.touched}
                            isError={errorHandler(props?.meta)}
                            initialValue={props.input.value}
                            inputRFF={props.input}
                        />
                    );
                }}
            </Field>
        );
    }, [fieldName, newClass, editable, values, newSelectedValue]);
};

export default TenthTwelthPercentage;
